import { Instagram, Facebook, Youtube, Phone, Mail } from "lucide-react";
import { business } from "@/config/site";

const quickLinks = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Gallery", id: "gallery" },
  { label: "Packages", id: "packages" },
  { label: "Contact", id: "contact" },
];

const services = ["Wedding Planning", "Stage Decoration", "Photography", "Tent House Setup", "Corporate Events"];

const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  const s = business.socials;
  const hasSocials = s.instagram || s.facebook || s.youtube;

  return (
    <footer data-testid="footer" className="bg-charcoal pt-20 pb-8 text-white/70">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-display text-3xl italic text-champagne">{business.name}</h3>
            <p className="mt-1 text-xs uppercase tracking-[0.25em] text-white/40">Events & Celebrations</p>
            <p className="mt-5 text-sm leading-relaxed text-white/55">
              Complete luxury event solutions under one roof — crafting stress-free,
              elegant and memorable celebrations.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="mb-5 text-xs uppercase tracking-[0.25em] text-champagne">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {quickLinks.map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-link-${l.id}`} onClick={() => go(l.id)}
                    className="transition-colors duration-300 hover:text-champagne">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="mb-5 text-xs uppercase tracking-[0.25em] text-champagne">Services</h4>
            <ul className="space-y-3 text-sm">
              {services.map((sv) => (
                <li key={sv}>
                  <button onClick={() => go("services")} className="transition-colors duration-300 hover:text-champagne text-left">
                    {sv}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-5 text-xs uppercase tracking-[0.25em] text-champagne">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-champagne" strokeWidth={1.5} />
                <a href={`tel:${business.phoneRaw}`} className="hover:text-champagne">{business.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-champagne" strokeWidth={1.5} />
                <a href={`mailto:${business.email}`} className="hover:text-champagne break-all">{business.email}</a>
              </li>
              <li className="text-white/55 leading-relaxed pt-1">{business.address}</li>
            </ul>
            {hasSocials && (
              <div className="mt-6 flex gap-3">
                {s.instagram && <a href={s.instagram} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="flex h-9 w-9 items-center justify-center rounded-full border border-champagne/30 hover:bg-champagne hover:text-charcoal transition-colors"><Instagram className="h-4 w-4" /></a>}
                {s.facebook && <a href={s.facebook} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="flex h-9 w-9 items-center justify-center rounded-full border border-champagne/30 hover:bg-champagne hover:text-charcoal transition-colors"><Facebook className="h-4 w-4" /></a>}
                {s.youtube && <a href={s.youtube} target="_blank" rel="noopener noreferrer" data-testid="social-youtube" className="flex h-9 w-9 items-center justify-center rounded-full border border-champagne/30 hover:bg-champagne hover:text-charcoal transition-colors"><Youtube className="h-4 w-4" /></a>}
              </div>
            )}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row">
          <p>© {new Date().getFullYear()} {business.fullName}. All rights reserved.</p>
          <p>Powered by <span className="text-champagne">{business.poweredBy}</span></p>
        </div>
      </div>
    </footer>
  );
};
